import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { initializeAdminSessionForToken } from "../utils/adminSession"

function ImpersonationBanner() {
  const navigate = useNavigate()
  const [active, setActive] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [adminName, setAdminName] = useState("")

  useEffect(() => {
    const check = () => {
      const isActive = localStorage.getItem("impersonationActive") === "1"
      setActive(isActive)
      setAdminName(localStorage.getItem("impersonatorName") || "Admin")
    }
    check()

    // Listen for storage events from other tabs
    const onStorage = (e) => {
      if (!e) return
      if (["impersonationActive", "impersonatorName"].includes(e.key)) {
        check()
      }
    }
    
    // Listen for custom event from same tab
    const onImpersonationChange = () => {
      check()
    }
    
    window.addEventListener("storage", onStorage)
    window.addEventListener("impersonationChanged", onImpersonationChange)
    
    return () => {
      window.removeEventListener("storage", onStorage)
      window.removeEventListener("impersonationChanged", onImpersonationChange)
    }
  }, [])

  if (!active) return null

  const fallbackPath = localStorage.getItem("impersonationReturnPath") || "/dashboard"
  const backLabel = String(fallbackPath).startsWith("/admin") ? "Admin" : "Back"

  const handleBack = () => {
    const fallbackPath = localStorage.getItem("impersonationReturnPath") || "/dashboard"
    try {
      const adminToken = localStorage.getItem("impersonatorToken")
      const returnPath = fallbackPath
      if (adminToken) {
        localStorage.setItem("token", adminToken)
        initializeAdminSessionForToken(adminToken)
      }
      localStorage.removeItem("impersonationActive")
      localStorage.removeItem("impersonatorToken")
      localStorage.removeItem("impersonatorUserId")
      localStorage.removeItem("impersonatorName")
      localStorage.removeItem("impersonatedUserId")
      localStorage.removeItem("impersonationReturnPath")

      navigate(returnPath)
      // Ensure app state reflects restored token
      setTimeout(() => {
        window.location.reload()
      }, 50)
    } catch (e) {
      // Fallback: reload
      window.location.href = fallbackPath
    }
  }

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <button
        onClick={handleBack}
        className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white text-xs font-semibold px-3 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-1.5 border border-white/20"
        title="Restore your previous session"
      >
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        <span>{backLabel}</span>
      </button>
    </div>
  )
}

export default ImpersonationBanner
